import { EColors, EFont } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledAddressList = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  position: relative;
  z-index: 0;

  &:after {
    position: absolute;
    top: -140%;
    left: -10%;
    display: block;
    content: "";
    width: 303px;
    height: 303px;
    border-radius: 50%;
    background: #da811b;
    opacity: 0.2;
    filter: blur(100px);
    z-index: -1;
  }
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    &:after {
      position: absolute;
      top: -12%;
      left: -25%;
      display: block;
      content: "";
      width: 243px;
      height: 243px;
      border-radius: 50%;
      background: #da811b;
      opacity: 0.2;
      filter: blur(100px);
      z-index: -1;
    }
  }
`;
export const StyledAddressItem = styled.li`
  @media screen and (max-width: 767px) {
    border-bottom: 1px solid ${EColors.neutral_600};
    padding-bottom: 24px;
    &:not(:first-child) {
      padding-top: 24px;
    }
  }
  @media screen and (min-width: 768px) {
    &:not(:first-child) {
      border-left: 1px solid ${EColors.neutral_600};
      padding-left: 24px;
    }
    &:not(:last-child) {
      padding-right: 24px;
    }
  }
`;
export const StyledAddress = styled.a`
display: inline-flex;
position: relative;
  text-decoration: none;
  font-family: ${EFont.Fira_Sans};
  margin-top: 16px;
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  font-feature-settings: "case" on;
  color:${EColors.accent_300};

  &:after {
    position: absolute;
    display: block;
    content: "";
    width: 0%;
    height: 1px;
    background: ${EColors.accent_300};
    position: absolute;
    bottom: -4px;
    left: 0;
    transition: all 0.2s ease;
  }
  &:hover:after {
    width: 100%;
    background: ${EColors.accent_300};
  }
`;
